import { useContext, useEffect, useState } from "react";

import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Switch,
  FormControlLabel,
} from "@material-ui/core";

import Btn from "../../../../components/buttons/Btn";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import SelectErp from "../../../../components/basics/SelectErp";
import useProdutoController from "../controllers/ProdutoController";
import { ProdutoContext } from "../contexts/ProdutoContext";
import { validNotNull } from "../../../../utils/validations";
import { notify } from "../../../../utils/notify";
import MaskService from "../../../../utils/mask/maskService";

export default function ModalProdutoTabelaPreco({
  open,
  setOpen,
  rowEdit,
  setRowEdit,
  usedIds,
}) {
  const { loadingInputs, priceTable, setPriceTable, pricesList } =
    useContext(ProdutoContext);
  const { handleCheckEditTablePrice } = useProdutoController();

  const [shippingCompany, setShippingCompany] = useState([]);
  const [marginModal, setMarginModal] = useState("0,00");
  const [priceDescryption, setPriceDescryption] = useState("");
  const [discountDefaultModal, setDiscountDefaultModal] = useState("0,00");
  const [discountMaxModal, setDiscountMaxModal] = useState("0,00");
  const [commissionModal, setCommissionModal] = useState("0,00");
  const [editTable, setEditTable] = useState(false);
  const [errorsModal, setErrorsModal] = useState({});

  const [newPricesList, setNewPricesList] = useState(
    pricesList.filter(
      (price) =>
        !usedIds
          .filter((el) => el !== (rowEdit?.data?.id ?? -1))
          .includes(price.id)
    )
  );

  const setters = {
    setMarginModal,
    setDiscountDefaultModal,
    setDiscountMaxModal,
    setCommissionModal,
    setEditTable,
  };

  useEffect(() => {
    if (!rowEdit?.data) {
      setShippingCompany([]);
      setMarginModal("0,00");
      setCommissionModal("0,00");
      setDiscountDefaultModal("0,00");
      setDiscountMaxModal("0,00");
      setPriceDescryption("");

      return;
    }

    const { data } = rowEdit;

    setEditTable(!!data.customValues);

    setMarginModal(
      data.margem
        ? MaskService.toMask("decimal", parseFloat(data.margem).toFixed(2))
        : "0,00"
    );

    setCommissionModal(
      data.comissaopadrao
        ? MaskService.toMask(
            "decimal",
            parseFloat(data.comissaopadrao).toFixed(2)
          )
        : "0,00"
    );

    setDiscountDefaultModal(
      data.descontopadrao
        ? MaskService.toMask(
            "decimal",
            parseFloat(data.descontopadrao).toFixed(2)
          )
        : "0,00"
    );

    setDiscountMaxModal(
      data.descontomaximopadrao
        ? MaskService.toMask(
            "decimal",
            parseFloat(data.descontomaximopadrao).toFixed(2)
          )
        : "0,00"
    );

    setPriceDescryption(data?.descricao ?? "");
    setShippingCompany(newPricesList.find((table) => table.id === data.id));
  }, [rowEdit, newPricesList]);

  useEffect(() => {
    if (!rowEdit?.data) return;

    const { data } = rowEdit;

    if (!shippingCompany) {
      setShippingCompany(newPricesList.find((el) => el.id === data.id));

      if (rowEdit.data.customValues) {
        setMarginModal(
          data.margem
            ? MaskService.toMask("decimal", parseFloat(data.margem).toFixed(2))
            : "0,00"
        );

        setCommissionModal(
          data.comissaopadrao
            ? MaskService.toMask(
                "decimal",
                parseFloat(data.comissaopadrao).toFixed(2)
              )
            : "0,00"
        );

        setDiscountDefaultModal(
          data.descontopadrao
            ? MaskService.toMask(
                "decimal",
                parseFloat(data.descontopadrao).toFixed(2)
              )
            : "0,00"
        );

        setDiscountMaxModal(
          data.descontomaximopadrao
            ? MaskService.toMask(
                "decimal",
                parseFloat(data.descontomaximopadrao).toFixed(2)
              )
            : "0,00"
        );
      }
    }
  }, [rowEdit, setShippingCompany, shippingCompany, newPricesList]);

  const handleCloseModal = () => {
    setOpen(false);
    setRowEdit(null);
    setNewPricesList([]);
  };

  const handleChangeShippingCompany = (value) => {
    setMarginModal(
      value?.porcmargemvenda
        ? MaskService.toMask(
            "decimal",
            parseFloat(value.porcmargemvenda).toFixed(2)
          )
        : "0,00"
    );
    setCommissionModal(
      value?.comissaopadrao
        ? MaskService.toMask(
            "decimal",
            parseFloat(value.comissaopadrao).toFixed(2)
          )
        : "0,00"
    );
    setDiscountDefaultModal(
      value?.descontopadrao
        ? MaskService.toMask(
            "decimal",
            parseFloat(value.descontopadrao).toFixed(2)
          )
        : "0,00"
    );
    setDiscountMaxModal(
      value?.descontomaximopadrao
        ? MaskService.toMask(
            "decimal",
            parseFloat(value.descontomaximopadrao).toFixed(2)
          )
        : "0,00"
    );
    setShippingCompany(value);
    setPriceDescryption(value?.descricao ?? "");
  };

  const handleAdd = () => {
    const validationInput = validNotNull([
      { key: "shippingCompany", value: shippingCompany },
    ]);

    setErrorsModal({
      ...validationInput.errorsValidation,
      accordionInput: validationInput.error,
    });
    if (validationInput.error) {
      return notify(
        "Verifique se os campos Obrigatorios estão preenchidos corretamente."
      );
    }

    const body = {
      id: shippingCompany.id,
      descricao: priceDescryption || shippingCompany.descricao,
      margem: marginModal,
      descontopadrao: discountDefaultModal,
      descontomaximopadrao: discountMaxModal,
      comissaopadrao: commissionModal,
      ativo: shippingCompany.ativo === "S" ? "S" : "N",
      customValues: true,
    };

    if (rowEdit && (rowEdit.index || rowEdit.index === 0)) {
      body.id = rowEdit.data.id || null;

      if (rowEdit.index !== -1) {
        const copy = [...priceTable];
        copy[rowEdit.index] = body;
        setPriceTable(copy);
      }
    } else {
      setPriceTable((current) => [...current, body]);
    }

    setShippingCompany([]);
    setMarginModal("");
    setDiscountDefaultModal("");
    setDiscountMaxModal("");
    setCommissionModal(null);
    setEditTable(false);
    setErrorsModal({});
    setOpen(false);
    setRowEdit(null);
    setNewPricesList([]);
  };

  return (
    <>
      <Dialog
        open={open}
        maxWidth="sm"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Cadastro de Tabela de Preço
          {rowEdit && rowEdit.id ? `: (${rowEdit.id})` : ""}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={editTable}
                    onChange={() =>
                      handleCheckEditTablePrice(
                        !editTable,
                        setters,
                        rowEdit || shippingCompany
                      )
                    }
                    color="primary"
                  />
                }
                label="Editar valores padrões para este produto"
                labelPlacement="end"
              />
            </Grid>
            <Grid item container>
              <Grid item xs={12}>
                <SelectErp
                  error={errorsModal.shippingCompany || false}
                  helperText={errorsModal.shippingCompany || ""}
                  loading={loadingInputs.pricesList || false}
                  label="Tabela de Preço"
                  value={shippingCompany}
                  setValue={setShippingCompany}
                  optionsList={newPricesList}
                  descriptionField="descricao"
                  onChange={handleChangeShippingCompany}
                />
              </Grid>
            </Grid>

            <Grid item sm={6} xs={12}>
              <TextFieldErp
                disabled={!editTable}
                label="Margem (%)"
                maxLength={8}
                value={marginModal}
                setValue={setMarginModal}
                mask="decimal"
              />
            </Grid>

            <Grid item sm={6} xs={12}>
              <TextFieldErp
                disabled={!editTable}
                label="Desconto Padrão"
                maxLength={6}
                value={discountDefaultModal}
                setValue={setDiscountDefaultModal}
                mask="decimal"
              />
            </Grid>

            <Grid item sm={6} xs={12}>
              <TextFieldErp
                disabled={!editTable}
                label="Desconto Máximo Permitido"
                maxLength={6}
                value={discountMaxModal}
                setValue={setDiscountMaxModal}
                mask="decimal"
              />
            </Grid>

            <Grid item sm={6} xs={12}>
              <TextFieldErp
                disabled={!editTable}
                label="Comissão"
                maxLength={6}
                value={commissionModal}
                setValue={setCommissionModal}
                mask="decimal"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Btn label="Cancelar" bgcolor="tertiary" onClick={handleCloseModal} />
          <Btn label="Salvar" onClick={handleAdd} />
        </DialogActions>
      </Dialog>
    </>
  );
}
